// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"51e09ee7","173":"9c703544","182":"51e09ee7","593":"51e09ee7","594":"51e09ee7","637":"51e09ee7","829":"51e09ee7","951":"51e09ee7","960":"51e09ee7"}[chunkId] + ".chunk.css";
};